// Lightweight canvas confetti — no external deps. Respects reduced motion.
const PALETTE = ["#C9A646", "#E2C46A", "#7C5CFF", "#38BDF8", "#FF5FA2", "#2ED3A0", "#FFD23F"];
const EMOJI = ["💛", "⭐", "✨"];

function reduced() {
  return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function makeCanvas() {
  let c = document.getElementById("confetti-canvas");
  if (!c) {
    c = document.createElement("canvas");
    c.id = "confetti-canvas";
    c.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:70;";
    document.body.appendChild(c);
  }
  c.width = window.innerWidth;
  c.height = window.innerHeight;
  return c;
}

export function burst({ x = 0.9, y = 0.6, count = 90, spread = 75, startVelocity = 42 } = {}) {
  if (reduced()) return;
  const canvas = makeCanvas();
  const ctx = canvas.getContext("2d");
  const ox = x * canvas.width;
  const oy = y * canvas.height;
  const particles = [];
  for (let i = 0; i < count; i++) {
    const angle = (-90 + (Math.random() - 0.5) * spread) * (Math.PI / 180);
    const vel = startVelocity * (0.5 + Math.random());
    const useEmoji = Math.random() < 0.2;
    particles.push({
      x: ox, y: oy,
      vx: Math.cos(angle) * vel * 0.4,
      vy: Math.sin(angle) * vel * 0.4,
      rot: Math.random() * Math.PI,
      vr: (Math.random() - 0.5) * 0.3,
      size: 6 + Math.random() * 6,
      color: PALETTE[(Math.random() * PALETTE.length) | 0],
      shape: useEmoji ? "emoji" : Math.random() < 0.5 ? "circle" : "square",
      emoji: EMOJI[(Math.random() * EMOJI.length) | 0],
      life: 220,
    });
  }
  let ticks = 0;
  function frame() {
    ticks++;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    let alive = false;
    for (const p of particles) {
      if (p.life <= 0) continue;
      alive = true;
      p.life--;
      p.vy += 1.1;
      p.x += p.vx;
      p.y += p.vy;
      p.rot += p.vr;
      const alpha = Math.min(1, p.life / 80);
      ctx.globalAlpha = alpha;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      if (p.shape === "emoji") {
        ctx.font = `${p.size * 2}px serif`;
        ctx.fillText(p.emoji, 0, 0);
      } else if (p.shape === "circle") {
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
        ctx.fill();
      } else {
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size);
      }
      ctx.restore();
    }
    ctx.globalAlpha = 1;
    if (alive && ticks < 240) requestAnimationFrame(frame);
    else ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
  requestAnimationFrame(frame);
}

export function doubleBurst() {
  burst({ x: 0.15, y: 0.7, count: 120 });
  burst({ x: 0.85, y: 0.7, count: 120 });
}

export function haptic(pattern) {
  try { if (navigator.vibrate) navigator.vibrate(pattern); } catch {}
}
